import * as React from "react";
import {
    List,
    TextInput,
    TextField,
    FunctionField,
    Datagrid,
    TopToolbar,
    Show,
    ShowButton,
    TabbedShowLayout,
    DateField,
    ExportButton,
    SelectInput,
    FilterButton
} from 'react-admin';

import { RowForm } from "@react-admin/ra-editable-datagrid";
import { iconStyle } from '../shared/Styles/iconsStyles';
import { fieldTabForShow } from '../shared/Styles/fieldsStyles';
import Typography from "@material-ui/core/Typography";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import Button from '@mui/material/Button';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

// Importo il css per i Bottoni
import { showButtonCss, exportButtonCss, filterButtonCss } from '../shared/Styles/buttonStyles';
import { listCss } from '../shared/Styles/listStyles';


const ListActions = () => (
    <TopToolbar>

        {/* <ExportButton label="Esporta" sx={exportButtonCss} /> */}
        <FilterButton sx={filterButtonCss} />

    </TopToolbar>
);


export const LogList = props => {

    return (
        <List
            pagination={null}
            title={<>
                <Button>
                    &nbsp;LISTA DEI LOGS
                </Button>
            </>}
            exporter={false}
            actions={<ListActions />}
            // aside={<LogFilterSidebar />}
            filters={LogFilters}
            {...props}
            // actions={null}
            perPage={100}
        // filters={aziendaFilters}
        >
            <Datagrid sx={listCss} bulkActionButtons={false}>
                {/*<WrapperField label="Logo Macro Area">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                        <CustomAvatarImage source="urlLogo" label="Logo" ></CustomAvatarImage>
                    </Box>
                </WrapperField> */}
                {<TextField source="id" ></TextField>}
                {<TextField source="email" ></TextField>}
                {<TextField source="tabella" ></TextField>}
                {<TextField source="rifId" ></TextField>}
                {<TextField source="operazione" ></TextField>}
                {<FunctionField
                    source="note" // used for sorting
                    label="Payload"
                    render={record => `${record.note}`}
                />}

                {<DateField label="Data Creazione" source="createdAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}
                {<DateField label="Data Ultima Modifica" source="updatedAt" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }}></DateField>}

            </Datagrid>
        </List>
    );
}


export const LogShow = (props) => {
    return (
        <Show title={<>
            <Button>
                &nbsp;Dettaglio Log
            </Button>
        </>} /* actions={<ShowActions />} */ actions={null}>


            {/*                 <Grid item xs={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                </Box>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
            <Grid item xs={12}>
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                <strong>Log Id:</strong> <TextField source="id"></TextField>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                Descrizione: <FunctionField source="descrizione" render={record => record && `${record.descrizione}`} />
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <TabbedShowLayout>
                <TabbedShowLayout.Tab label="Grafico" sx={fieldTabForShow} icon={<LeaderboardIcon sx={iconStyle} />}>
                    <Grid item xs={12}>

                    </Grid>
                </TabbedShowLayout.Tab>
            </TabbedShowLayout>
        </Show>
    );
}

const ShowTopToolbarDettaglio = () => (
    <TopToolbar>
        <ShowButton sx={showButtonCss} label="Dettaglio" />
    </TopToolbar>
);

const ShowActionsForEdit = () => (
    <ShowTopToolbarDettaglio></ShowTopToolbarDettaglio>
);



const LogFilters = [
    <TextInput source="id" label="Log Id" />,
    <TextInput source="email" label="Email Account" />,
    <TextInput source="tabella" label="Tabella" />,
    <TextInput source="note" label="Note" />,
    <SelectInput label="Operazione" source="operazione" choices={[
        { id: 'create', name: 'create' },
        { id: 'patch', name: 'patch' },
        { id: 'remove', name: 'remove' }]} />
];